import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import NicePayLanding from './components/NicePayLanding';

function App() {
  return (
    <div>
      <NicePayLanding />
    </div>
  );
}

export default App;
